import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  productLineNameWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  productLineName: {
    marginLeft: '0.5rem',
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700,
      color: colors.neutral[900],
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
